import {
  ALLOWED_CHAT_ASSET_TYPES,
  CHAT_ACCEPT_MIME_TYPES,
} from "@v2/features/assets/constants";

export function isValidChatAssetType(file: {
  name: string;
  type: string;
}): boolean {
  if (CHAT_ACCEPT_MIME_TYPES.includes(file.type)) {
    return true;
  }

  const extension = file.name.toLowerCase().split(".").pop();
  return extension ? ALLOWED_CHAT_ASSET_TYPES.includes(extension) : false;
}
